import { Dialog } from '@sib/ui';
import { EditingTag } from '@sib/utils';
import { TagDialogContent } from './TagDialogContent';
import { NEW_TAG_KEY, TagDialogState } from './TagDialog.utils';

export interface TagDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tagToEdit: EditingTag | null;
  onSave: (name: string, color: string, uuid?: string) => void;
  isSaving?: boolean;
  onRemove?: (uuid: string) => void;
}

export const TagDialog = ({
  open,
  onOpenChange,
  tagToEdit,
  onSave,
  isSaving = false,
  onRemove,
}: TagDialogProps) => {
  const contentKey = `${open ? TagDialogState.Open : TagDialogState.Closed}:${tagToEdit?.uuid ?? NEW_TAG_KEY}`;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <TagDialogContent
        key={contentKey}
        tagToEdit={tagToEdit}
        onSave={onSave}
        isSaving={isSaving}
        onRemove={onRemove}
      />
    </Dialog>
  );
};
